import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../../chunks/tslib.es6.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";

var e = function e(_e2) {
  var t = /*#__PURE__*/function (_e) {
    _inherits(t, _e);

    var _super = _createSuper(t);

    function t() {
      var _this;

      _classCallCheck(this, t);

      for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
        o[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(o)), _this.goToOverride = null, _this.view = null;
      return _this;
    }

    _createClass(t, [{
      key: "callGoTo",
      value: function callGoTo(o) {
        var r = this.view;
        return this.goToOverride ? this.goToOverride(r, o) : r.goTo(o.target, o.options);
      }
    }]);

    return t;
  }(_e2);

  return o([r()], t.prototype, "goToOverride", void 0), o([r()], t.prototype, "view", void 0), t = o([s("esri.widgets.support.GoTo")], t), t;
};

export { e as GoToMixin };